import { Link } from "react-router-dom";

/**
 * Creates objects with link, title and picture. For use with JumboList. 
 * Also generates a key value.
 */
export class LinkItem {
  /**
   * 
   * @param link to a page registered in this system's router. Must match name given in router.
   * @param title Title of the link.
   * @param pic Picture of the link (optional). Of course can actually be anything, this is JavaScript. 
   */
  constructor(link, title, pic) {
    this.link = link;
    this.title = title;
    this.pic = pic;
    this.key = link + Math.floor(Math.random() * 1000) + 1; //for satisfying uniqueness requirement
  }
}

/**
 * Takes a list or array of LinkItems and generates a vertical jumbo list of them. 
 * 
 * @param items an iterable of LinkItems.
 * @param height CSS rule for height of the list component
 * @param tsize Text size as a CSS rule.
 * @returns Styled list element where key = description text, link = router link destination.
 */
export function JumboList({items, height, tsize}) {
  height = height === undefined ? 'h-40' : height;
  tsize = tsize === undefined ? 'md:text-5xl text-4xl' : tsize;
  const links = items.map(item =>
    <Link key={item.key} to={item.link}>
      <div className={`
      jumbolist bg-blue-200 dark:bg-blue-500 
      rounded-3xl shadow-md ring-2 ring-orange-400
      ${height} mb-3 bg-cover
      text-center flex items-center justify-center 
      ${tsize} font-semibold text-black dark:text-white
      cursor-pointer
      `}
      style={{backgroundImage: `url(${item.pic})`}}>
        {item.title}
      </div>
    </Link>
  );
  return (
    <div className="flex justify-center min-h-screen">
      <div className="w-5/6 lg:w-2/3">
        {links}
      </div>
    </div>
  );
}